export const SITE = {
  name: "Ebikes&Gear",
  domain: "ebikesandgear.co.uk",
  url: "https://ebikesandgear.co.uk",
  tagline: "Premium Carbon Bikes & E-Bikes for Europe",
  email: "sales@ebikesandgear.co.uk",
  phone: "+44 7806 925473",
  whatsapp: "447806925473",
  whatsappHref: "https://wa.me/447806925473",
  address: "St George Lane, Kent CT1 2SY, United Kingdom",
  city: "Canterbury",
  country: "United Kingdom",
  hours: [
    { day: "Monday – Friday", time: "9:00 – 18:00" },
    { day: "Saturday", time: "10:00 – 17:00" },
    { day: "Sunday", time: "Closed" },
  ],
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    twitter: "https://x.com",
    youtube: "https://youtube.com",
  },
  mapsEmbed:
    "https://www.google.com/maps?q=St+George+Lane,+Canterbury,+Kent+CT1+2SY,+United+Kingdom&output=embed",
};

export const NAV = [
  { label: "Shop", to: "/shop" },
  {
    label: "Categories",
    to: "/shop",
    children: [
      { label: "Road Bikes", to: "/category/road" },
      { label: "Mountain Bikes", to: "/category/mountain" },
      { label: "E-Bikes", to: "/category/electric" },
      { label: "Gravel Bikes", to: "/category/gravel" },
      { label: "Specialized Framesets", to: "/category/framesets" },
      { label: "Sur-Ron Electric Bikes", to: "/category/surron" },
      { label: "Components & Parts", to: "/category/components" },
    ],
  },
  {
    label: "Services",
    to: "/servicing",
    children: [
      { label: "Bike Repairs", to: "/repairs" },
      { label: "Bike Servicing", to: "/servicing" },
      { label: "Bike Rentals", to: "/rentals" },
    ],
  },
  { label: "Blog", to: "/blog" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const BRANDS = ["SPECIALIZED", "TREK", "SUR-RON", "SHIMANO", "SRAM", "BOSCH", "FOX", "ROCKSHOX", "ROVAL"];

export const BENEFITS = [
  { icon: "Truck", title: "Free UK & EU Delivery", text: "Fast, free, fully-insured delivery on every bike across the UK and EU." },
  { icon: "ShieldCheck", title: "Lifetime Frame Warranty", text: "Specialized & Trek lifetime frame cover, plus 2 years on batteries and motors." },
  { icon: "CreditCard", title: "Simple Bank Transfer", text: "Order online, pay by direct bank transfer — your bike is reserved for 48 hours." },
  { icon: "Wrench", title: "Expert Servicing", text: "Certified technicians keep your ride performing like the day you bought it." },
];

export const WHY_US = [
  { icon: "Medal", title: "2026 Flagship Stockist", text: "Authorised Specialized S-Works and Trek dealer with launch-day allocations." },
  { icon: "Lightning", title: "Premium Components Only", text: "Genuine Shimano, SRAM, Bosch and RockShox parts — no grey imports, ever." },
  { icon: "MapPin", title: "Europe-Wide Delivery", text: "From Kent to Lisbon — Germany, France, Spain and the Netherlands in 5–10 days." },
  { icon: "Headset", title: "Lifetime Rider Support", text: "Real humans, real expertise — for the entire life of your bike." },
  { icon: "Recycle", title: "Sustainable Mobility", text: "Every ride replaces a car journey. Better for you, better for the planet." },
  { icon: "Star", title: "Rated Excellent", text: "Thousands of 5-star reviews from happy riders across the continent." },
];

export const CITIES = [
  "Canterbury", "London", "Manchester", "Birmingham", "Edinburgh",
  "Paris", "Berlin", "Amsterdam", "Brussels", "Madrid", "Milan", "Lisbon",
];
